import React, { useContext, useMemo } from 'react'
import { CardSwiper } from '../CardSwiper'
import { LeagueContext } from '../../Context'
import { EventBox } from './EventBox/EventBox'
import { isPostseason, determineTickerStart } from '../../Utils'

type GameTickerProps = {
  hideInPostseason?: boolean
  teamId?: string
}

export const GameTicker: React.FC<GameTickerProps> = ({
  hideInPostseason = false,
  teamId,
}) => {
  const { events } = useContext(LeagueContext)!

  const tickerEvents = useMemo(() => {
    if (!events || events.length === 0) return []
    if (hideInPostseason && isPostseason(events) && !teamId) return []

    return teamId
      ? events.filter(
          (ev) =>
            ev.homeTeam?.officialId === teamId || ev.awayTeam?.officialId === teamId
        )
      : events
  }, [events, teamId])

  const startingGame = useMemo(() => {
    if (!tickerEvents || tickerEvents.length === 0) {
      return '0'
    }
    if (hideInPostseason && isPostseason(tickerEvents)) {
      return '0'
    }
    return `${determineTickerStart(tickerEvents)}`
  }, [tickerEvents, hideInPostseason])

  const tickerItems = useMemo(() => {
    return tickerEvents.map((ev) => <EventBox key={ev.id} eventData={ev} />)
  }, [tickerEvents])

  if (!tickerEvents || tickerEvents.length < 1) return null


  return (
    <>
      <CardSwiper
        items={tickerItems}
        cardSize="ticker"
        idx={startingGame}
        showPagination
      />
    </>
  )
}
